import { required, minValue, minLength, email } from 'vuelidate/lib/validators'

export default {
  organisationseinheit: {
    name: { required, minLength: minLength(1) }
  },
  jahr: { required, minValue: minValue(1409) },
  email: { required, email }
}



// WEBPACK FOOTER //
// ./src/validation/Export.js